import L from 'leaflet';

const symbols = { house: '🏠', store: '🏪', resto: '🍽️', church: '⛪', building: '🏢', tree: '🌳', mountain: '⛰️', school: '🏫', hospital: '🏥', terminal: '🚉', amusement: '🎡', playground: '🛝', tourism: '📸', tennis: '🎾', bank: '🏦', gasStation: '⛽', basketballCourt: '🏀', bakery: '🥐', friedChicken: '🍗', billiardHall: '🎱', motorSale: '🏍️', pizza: '🍕', chickenStatue: '🐓', tower: '🗼', watchTower: '🏯', arena: '🏟️', publicMarket: '🛒', convenienceStore: '🏪', coffeeShop: '☕', burger: '🍔', beer: '🍺', tea: '🍵', bread: '🍞', meat: '🥩' };
export function featureScale(zoom) {
  const scale = Math.min(1.6, Math.pow(2, (zoom - 16) / 3));
  return { iconSize: Math.max(4, 20 * scale), roadWidth: zoom <= 10 ? 0 : Math.max(0.5, 5 * scale), labelSize: Math.max(3, 8 * scale), labelsVisible: zoom >= 13 };
}
export function addPlatformFeatures(map, features, { onFeatureClick } = {}) {
  const group = L.layerGroup().addTo(map);
  const roadLabels = L.layerGroup().addTo(group);
  const entries = features.map(feature => {
    const isPoint = feature.geometry.type === 'Point';
    const layer = isPoint
      ? L.marker([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], { interactive: Boolean(onFeatureClick), bubblingMouseEvents: false, icon: L.divIcon({ className: '', html: '', iconSize: [10, 10] }) })
      : L.polyline(feature.geometry.coordinates.map(([lng, lat]) => [lat, lng]), { color: '#16a34a', weight: 5, ...(onFeatureClick ? { bubblingMouseEvents: false } : {}) });
    if (onFeatureClick) layer.on('click', () => onFeatureClick(feature));
    layer.addTo(group);
    return { feature, layer, isPoint };
  });
  const update = () => {
    const size = featureScale(map.getZoom());
    roadLabels.clearLayers();
    entries.forEach(({ feature, layer, isPoint }) => {
      if (isPoint) {
        const element = document.createElement('span');
        element.style.cssText = `display:block;position:relative;width:${size.iconSize}px;height:${size.iconSize}px;line-height:1`;
        const icon = document.createElement('span');
        icon.textContent = symbols[feature.icon] || symbols.house;
        icon.style.cssText = `display:block;font-size:${size.iconSize}px;filter:drop-shadow(0 1px 1px white)`;
        element.appendChild(icon);
        if (size.labelsVisible) {
          const name = document.createElement('span');
          name.textContent = feature.name;
          name.style.cssText = `position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);text-align:center;font-size:${size.labelSize}px;font-weight:500;color:#000;white-space:nowrap;text-shadow:-1px -1px 0 white,1px -1px 0 white,-1px 1px 0 white,1px 1px 0 white,0 0 2px white;pointer-events:none`;
          element.appendChild(name);
        }
        layer.setIcon(L.divIcon({ className: '', html: element, iconSize: [size.iconSize, size.iconSize], iconAnchor: [size.iconSize / 2, size.iconSize / 2] }));
      } else {
        layer.setStyle({ weight: size.roadWidth, opacity: size.roadWidth ? 1 : 0 });
        if (size.labelsVisible && size.roadWidth) {
          const coordinates = feature.geometry.coordinates;
          const projected = coordinates.map(([lng, lat]) => map.project([lat, lng]));
          const segments = projected.slice(1).map((end, index) => {
            const start = projected[index];
            return { start, end, length: Math.hypot(end.x - start.x, end.y - start.y) };
          }).filter(segment => segment.length > 0);
          const totalLength = segments.reduce((sum, segment) => sum + segment.length, 0);
          const spacing = Math.max(240, String(feature.name || '').length * size.labelSize * 0.6 + 80);
          const labelCount = totalLength < 20 ? 0 : Math.max(1, Math.floor(totalLength / spacing));
          let segmentIndex = 0, distanceBefore = 0;
          for (let index = 0; index < labelCount; index++) {
            const distance = totalLength * (index + 0.5) / labelCount;
            while (segmentIndex < segments.length - 1 && distanceBefore + segments[segmentIndex].length < distance) {
              distanceBefore += segments[segmentIndex++].length;
            }
            const { start, end, length } = segments[segmentIndex];
            const fraction = (distance - distanceBefore) / length;
            let angle = Math.atan2(end.y - start.y, end.x - start.x) * 180 / Math.PI;
            if (angle > 90) angle -= 180;
            if (angle < -90) angle += 180;
            const text = document.createElement('span');
            text.textContent = feature.name;
            text.style.cssText = `position:absolute;left:0;top:0;transform:translate(-50%,-50%) rotate(${angle}deg);font-size:${size.labelSize}px;font-weight:500;color:#000;white-space:nowrap;max-width:${Math.floor(Math.min(totalLength, spacing) - 8)}px;overflow:hidden;text-overflow:ellipsis;text-shadow:-1px -1px 0 white,1px -1px 0 white,-1px 1px 0 white,1px 1px 0 white,0 0 2px white;pointer-events:none`;
            const midpoint = map.unproject(L.point(start.x + (end.x - start.x) * fraction, start.y + (end.y - start.y) * fraction));
            L.marker(midpoint, { interactive: false, keyboard: false, icon: L.divIcon({ className: '', html: text, iconSize: [0, 0], iconAnchor: [0, 0] }) }).addTo(roadLabels);
          }
        }
      }
    });
  };
  update();
  map.on('zoomend', update);
  const remove = group.remove.bind(group);
  group.remove = () => { map.off('zoomend', update); return remove(); };
  return group;
}
